import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }

import { useAuth } from '@/store/useAuth'
import PayPalService from '@/services/PayPalService'
import { onMounted, ref } from 'vue'
import router from '@/router';
import main from '@/data/main.js';


export default /*#__PURE__*/_defineComponent({
  __name: 'ProdevValidator',
  setup(__props) {

const loading = ref(true)
const service = new PayPalService()
const store = useAuth()

onMounted(async () => {
    if (!store.token) {
        router.push({name: 'auth'})
        return
    }
    loading.value = true

    const response = await service.checkSub(store.token)
    if(response.status != 'ACTIVE' && main.monetization_type == "subscription") {
        router.push({name: 'register-free'})
    }

    loading.value = false
})

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!

  return (loading.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_v_icon, {
          name: "ri-loader-2-fill",
          animation: "spin",
          class: "icon"
        })
      ]))
    : _createCommentVNode("", true)
}
}

})